export const toFloat = (num: number) => num / 100
